// ============================================================
// shared/src/dto/openapi.dto.ts
// policy-url / report-query schema
// ============================================================

import { z } from 'zod';

/** policy-url 请求 schema */
export const policyUrlRequestSchema = z.object({
  outBizId: z.string().min(1),
  productId: z.string().min(1),
  returnUrl: z.string().optional(),
});

export type PolicyUrlRequest = z.infer<typeof policyUrlRequestSchema>;

/** policy-url 响应类型 */
export interface PolicyUrlResponse {
  success: boolean;
  resultCode: string;
  resultMsg: string;
  policyUrl?: string;
  appBizId?: string;
}

/** report-query 请求 schema */
export const reportQueryRequestSchema = z.object({
  outBizId: z.string().optional(),
  appBizId: z.string().optional(),
  bxBizId: z.string().optional(),
  eventType: z.string().optional(),
  source: z.enum(['local', 'jd']).optional().default('local'),
}).refine(
  (data) => data.outBizId || data.appBizId || data.bxBizId,
  { message: '至少提供 outBizId / appBizId / bxBizId 中的一个' }
);

export type ReportQueryRequest = z.infer<typeof reportQueryRequestSchema>;

/** report-query 响应类型 */
export interface ReportQueryResponse {
  success: boolean;
  resultCode: string;
  resultMsg: string;
  appBizId?: string;
  bxBizId?: string;
  orderStatus?: string;
  events?: {
    eventType: string;
    eventTime: string;
    callbackDate: string;
    detail?: Record<string, unknown>;
  }[];
}
